<div class="filter-bar">
  <div class="filters-container">
    <ng-content></ng-content>
  </div>
  @if (showResetButton()) {
    <div class="reset-button-container">
      <button
        mat-raised-button
        (click)="resetFilters.emit()"
        class="reset-button"
      >
        <mat-icon>refresh</mat-icon>
        Reset Filters
      </button>
    </div>
  }
</div>
